import $ from 'jquery';
import layout from '~/js/services/layout';
import scroller from '~/js/services/scroller';


// Container element (internal.$e) is the source of truth for the positioning
// and sizing of the sticky element (elements.sticky). It should be `position:
// static` with the following CSS and modifier classes applied:
//
// internal.threshold (scroll position when stickiness begins) = `top`
// internal.offset (distance from top minus threshold) = `.sticky--offset`


const sticky = function (options) {
    let o, m, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: ''
    }, options);


    m = sticky.markup;


    internal = {
        $e: o.$e || $(o.selector),
        stuck: false,
        threshold: 0,
        offset: false
    };


    elements = {
        sticky: internal.$e.find(`.${m.STICKY}`)
    };


    fn = {
        init () {
            if (internal.$e.hasClass(m.OFFSET)) {
                internal.offset = true;
            }

            fn.updatePosition();
            fn.updateState(scroller.getScrollTop());

            internal.$e.addClass(m.SETUP);

            scroller.onScroll(handlers.scrolled);
            layout.onResize(handlers.resized);
        },

        updatePosition () {
            const offset = internal.offset ? internal.$e.offset().top : 0;
            const threshold = parseInt(internal.$e.css('top'), 10) || 0;

            internal.threshold = offset ? offset - threshold : threshold;
        },

        updateState (scrollTop) {
            if (internal.stuck) {
                if (scrollTop < internal.threshold) {
                    elements.sticky.removeClass(m.STUCK);
                    internal.stuck = false;
                }
            } else {
                if (scrollTop >= internal.threshold) {
                    elements.sticky.addClass(m.STUCK);
                    internal.stuck = true;
                }
            }
        },

        destroy () {
            scroller.offScroll(handlers.scrolled);
        }
    };


    handlers = {
        scrolled (d) {
            fn.updateState(d.scrollTop);
        },

        resized () {
            fn.updatePosition();
            fn.updateState(scroller.getScrollTop());
        }
    };


    fn.init();
};


sticky.markup = {
    // dom selector
    CONTAINER: 'sticky',
    STICKY: 'sticky__element',

    // modifiers
    OFFSET: 'sticky--offset',

    // states
    STUCK: 'state-stuck',
    SETUP: 'state-setup'
};


export default sticky;



// WEBPACK FOOTER //
// ./assets/js/components/sticky.js